<template>
  <div class="col-12 col-md-12 col-lg-6">
    <div class="tit text-center">
      <h1>Natureza da Ocupação</h1>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form @submit="onSubmit">
          <div class="form-group text-left">
            <label for="NaturezaOcupacao">
              Natureza Ocupação
            </label>
            <at-select v-model="currentUser.Social.NaturezaOcupacao" filterable size="large" required placeholder="Selecione...">
              <at-option v-for="(occupation, index) in occupations" :key="`occupationsOptions${index}`" :value="occupation.value">{{occupation.label}}</at-option>
            </at-select>
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      occupations : [
        {value: 1, label: 'MEI'},
        {value: 2, label: 'Autônomo'},
        {value: 3, label: 'Profissional liberal'},
      ]
    }
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      const newData = {Social: this.currentUser.Social}
      this.$emit('on-submit', newData)
    }
  },
  mounted() {
    document.getElementsByClassName("at-select__input")[0].setAttribute("required", "");
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationSocial/NaturezaOcupacaoStep.vue